$(function() {
    window.enhance.loadJS.ready(['videoBackground', 'jQuery'],
    {
        success: function () {
            var videoContainer = "hero__player";

            var videoEl = $("#" + videoContainer);
            var videoSrc = videoEl.data("src");
            var myOptions = {
                heuristicProfile: "HighQuality", //we want good quality on a background video. The whole point :)
                controls: false,
                autoplay: true,
                fluid: true,
                muted: true
                //poster: "yourPoster.jpg",
            };
            myOptions = $.extend(true, myOptions, window.ampSettings);

            var myPlayer = amp(videoContainer, myOptions);

            //Mute BG Video
            myPlayer.muted(true);
            myPlayer.autoplay(true);

            //Register for events after intialization not in Ready function to ensure all event are captured
            myPlayer.addEventListener(amp.eventName.play, _ampEventHandler);
            myPlayer.addEventListener(amp.eventName.ended, _ampEventHandler);
            myPlayer.addEventListener(amp.eventName.loadstart, _ampEventHandler);

            myPlayer.src([
                {
                    src: videoSrc
                }
            ]);

            function _ampEventHandler(evt) {
                if ("loadstart" == evt.type) {
                    //TODO - Support multiple video bg?
                    $("." + videoContainer).css("opacity", "1");
                }
                if ("play" == evt.type) {
                    //TODO - Support multiple video bg?
                    $("." + videoContainer).css("opacity", "1");
                }
                if ("ended" == evt.type) {
                    myPlayer.play(); //loop
                }
            }

            // as of Chrome 66, autoplay videos will only play if muted is set to true, directly on the video tag
            var videoTag = document.querySelector('#hero__player video');
            videoTag.muted = true;
            videoTag.autoplay = true;

            var videoPlayer = $(".hero__media--background").find("video");

            // "Playsinline" is required for autoplay on mobile devices
            videoPlayer.attr("playsinline", true);
            videoPlayer.attr("loop", true);

            myPlayer.play(); //try force play
        }
    });
});